/**
* @ngdoc component
* @name catalog.component:itxProductMarquee
* @description
* Show a marquee text over a image in the grids.
*/
(function() {
    'use strict';

    var itxProductMarquee = {
        bindings: {
        },
        controller:   itxProductMarqueeCtrl,
        templateUrl: 'product-marquee.component.html'
    };

    itxProductMarqueeCtrl.$inject = [
        'ItxStaticResourceSvc'
    ];

    function itxProductMarqueeCtrl (
        ItxStaticResourceSvc
    ) {
        var _this = this;

        _this.$onInit = function () {
            _this.frameBg = ItxStaticResourceSvc.getImage('marquee/frame.svg');
            _this.marqueeImage = ItxStaticResourceSvc.getImage('marquee/marquee.svg');
        };

    }

    angular.module('itxApp.common')
    .component('itxProductMarquee',itxProductMarquee);

})();